<template>
  <div v-if="$store.state.user">
    <Header
      :nav-collapse="navCollapse"
      @changeNavCollapse="changeNavCollapse"
    />
    <el-container class="home flex">
      <aside class="side-menu">
        <Menu :nav-collapse="navCollapse" />
      </aside>
      <el-main class="bg-gray-100 main-page">
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Header from './PageHeader'
import Menu from './PageMenu.vue'
import api from '@/api'

export default {
  name: 'Home',
  components: {
    Header,
    Menu,
  },
  data() {
    return {
      navCollapse: false,
    }
  },
  mounted() {
    api.profile().then(res => {
      this.$store.state.user = res.data
    })
  },
  methods: {
    changeNavCollapse() {
      this.navCollapse = !this.navCollapse
    },
  },
}
</script>
<style lang="scss" scoped>
.side-menu {
  height: calc(100vh - 60px);
  overflow: scroll;
}
.home {
  height: calc(100vh - 60px);
}
.main-page {
  padding-top: 48px;
}
</style>
